import { z } from "zod";

export const newVideoSchema = z.object({
  name: z.string().optional(),
  link: z.string().url("اللينك غير صحيح").min(1, "لينك الفيديو مطلوب"),
});
